"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/styles");

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SkeletonStyled = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      '&:after': {
        background: 'linear-gradient(90deg, transparent, rgb(151 151 151 / 23%), transparent)'
      }
    }
  };
})(_Skeleton.default);
var _default = SkeletonStyled;
exports.default = _default;